import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { CreateBadgeRequest, UpdateBadgeRequest } from '../../../api/badge/badge.types';
import { RootState } from '../../../types/common.types';

import { useBadgeApi } from '../../../api/badge/useBadgeApi';

import BadgeSettings from '../../../components/screens/settings/badge/BadgeSettings';

const BadgeSettingsContainer = () => {
  const badges = useSelector(({ badge }: RootState) => badge.badges);

  const {
    createBadge: createBadgeRequest,
    viewBadges,
    updateBadge: updateBadgeRequest,
    deleteBadge: deleteBadgeRequest
  } = useBadgeApi();

  useEffect(() => {
    viewBadges();
  }, [viewBadges]);

  const createBadge = (badge: CreateBadgeRequest, onSuccess: () => void) => {
    createBadgeRequest(badge, onSuccess);
  };

  const updateBadge = (badge: UpdateBadgeRequest, onSuccess: () => void) => {
    updateBadgeRequest(badge, onSuccess);
  };

  const deleteBadge = (externalReference: string, onSuccess: () => void) => {
    deleteBadgeRequest({ badgeExternalReference: externalReference }, onSuccess);
  };

  return (
    <BadgeSettings badges={badges} createBadge={createBadge} updateBadge={updateBadge} deleteBadge={deleteBadge} />
  );
};

export default BadgeSettingsContainer;
